import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class WindowsNotificationService {
  ACTIONS = {
    showGapReport: new Subject(),
    closeGapReport: new Subject(),
    showMissingSubtitlesReport: new Subject(),
    showMissingAudiosReport: new Subject(),
    showEmptyContractsReport: new Subject(),
    closeMissingSubtitlesReport: new Subject(),
    closeMissingAudiosReport: new Subject(),
    closeEmptyContractsReport: new Subject(),
  };

  EVENTS = {};

  constructor() {}
}
